import { ModalProps } from '@pypestream/design-system';
import { useRef } from 'react';

export const useGenericModal = () => {
  const modalRef = useRef<ModalProps>(null);

  const openModal = () => {
    if (modalRef?.current) {
      modalRef.current.open = true;
    }
  };

  const closeModal = () => {
    if (modalRef?.current) {
      modalRef.current.open = false;
    }
  };

  return { modalRef, openModal, closeModal };
};
